module.exports = __webpack_public_path__ + "img/3_james_s.8b1d4378.png";